import { jsxs as r, jsx as l } from "react/jsx-runtime";
const o = (h) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...h,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M51.893 45.85h-4.029v-4.03l-2.015.54v3.489h-4.03l.54 2.015h3.489v4.029h2.015v-4.029h4.029v-2.015l.001.001ZM38.098 34.433H25.902v2h12.196v-2Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M46.83 35.76c-6.138 0-11.114 4.976-11.114 11.114 0 6.138 4.976 11.114 11.114 11.114 6.138 0 11.114-4.976 11.114-11.114 0-6.138-4.975-11.114-11.114-11.114Zm0 19.231c-4.476 0-8.117-3.641-8.117-8.117 0-4.476 3.641-8.117 8.117-8.117 4.476 0 8.117 3.641 8.117 8.117 0 4.476-3.641 8.117-8.117 8.117Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M34.654 42.006H15.01V28.865h33.989v5.076c1.046.175 2.05.473 2.997.881v-5.957h4.45l.803-2.997h-5.214l-5.602-13.874H17.29l-5.223 13.874H6.779l.803 2.997h4.433v23.097h2.997v-.015h5.6v-6.944h13.239c.15-1.044.422-2.048.804-2.998l-.001.001Zm1.48-27.017h8.358l4.259 10.878h-16.98l4.363-10.878Zm-16.851 0h12.538l-4.363 10.878H15.312l3.971-10.878Z"
        }
      )
    ]
  }
);
export {
  o as AddYourCar
};
